import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=9a955830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a955830"]])

export default __exports__